import React from 'react'
import InviteBotButton from './InviteBotButton'
import './Hero.css'

function Hero() {
  return (
    <section className="hero" aria-label="Section principale">
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="gradient-text">Pokefarm</span>
          <br />
          Votre aventure Pokémon sur Discord
        </h1>
        <p className="hero-description">
          Capturez, évoluez et complétez votre Pokédex dans un bot Discord unique.
          Explorez les régions, farmez tous les Pokémon et devenez le meilleur dresseur !
        </p>
        <nav className="hero-buttons" aria-label="Actions principales">
          <InviteBotButton className="btn btn-primary">
            Inviter le bot
          </InviteBotButton>
          <a
            href="https://discord.gg/SrTAFyRt8D"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary"
            aria-label="Rejoindre le serveur Discord"
          >
            Découvrir
          </a>
        </nav>
      </div>
      <div className="hero-decoration" aria-hidden="true">
        <div className="pokeball" role="img" aria-label="Pokéball décorative"></div>
      </div>
    </section>
  )
}

export default Hero
